import { PoDetailsEditLogoContainer } from "./container";

export const PoDetailsEditLogoPane = () => {
  return <PoDetailsEditLogoContainer />;
};
